import axios from './axiosConfig'

export const createSlider = async (formData) => {
  // Create a FormData object to properly handle multipart/form-data
  const data = new FormData()

  // Append text fields to FormData
  data.append('title', formData.title)
  data.append('description', formData.description)
  data.append('pageUrl', formData.pageUrl)

  // Append the image file - formData.image[0] contains the File object
  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  try {
    const response = await axios.post('/slider', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.log('Slider creation response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error creating slider:', error)
    throw error
  }
}

export const updateSlider = async (id, formData) => {
  // Create a FormData object to properly handle multipart/form-data
  const data = new FormData()

  // Append text fields to FormData
  data.append('title', formData.title)
  data.append('description', formData.description)
  data.append('pageUrl', formData.pageUrl)

  // Append the image file only if a new one is provided
  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  try {
    const response = await axios.put(`/slider/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    // console.log('Slider update response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error updating slider:', error)
    throw error
  }
}

export const getSliderById = async (id) => {
  try {
    const response = await axios.get(`/slider/${id}`, {
      withCredentials: true,
    })

    // console.log('Get slider by ID response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching slider:', error)
    throw error
  }
}

export const allSlider = async () => {
  try {
    const response = await axios.get('/slider', {
      withCredentials: true,
      headers: {
        Accept: 'application/json',
      },
    })

    console.log('Raw API response type:', response)
    return response.data
  } catch (error) {
    console.error('Error fetching sliders:', error)
    throw error
  }
}

export const deleteSlider = async (id, otp) => {
  try {
    const response = await axios.delete(`/slider/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete slider response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting slider:', error)
    throw error
  }
}

export const sendMail = async (id) => {
  try {
    const response = await axios.get(`/slider/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching sliders:', error)
    throw error
  }
}
